export enum PopupWindowMode {
  DEFAULT = "default",
  BOTTOM = "bottom",
  RIGHT = "right"
}